import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import CommentForm from '../post/CommentForm';
import CommentItem from '../post/CommentItem';
import { addLike, removeLike, deletePost } from '../../actions/post';

const PostItem = ({
  addLike,
  removeLike,
  deletePost,
  auth,
  post: { _id, text, name, avatar, user, likes, comments, date },
  showActions
}) => {
  const [displayCommentSection, toggleCommentSection] = useState(false);

  return (
    <Fragment>
      <div className="card rounded-0 mb-3 shadow-sm">
        <div className="post shadow-sm">
          <div className="card-body px-3 pt-3 pb-2">
            {showActions && (
              <Fragment>
                {!auth.loading && user === auth.user._id && (
                  <a
                    href="#!"
                    onClick={() => deletePost(_id)}
                    className="text-secondary float-right delete"
                  >
                    <i className="fas fa-times"></i>
                  </a>
                )}
              </Fragment>
            )}
            <div className="d-flex">
              <img src={avatar} className="post-profile-pic" alt="" />
              <div className="ml-2">
                <Link to={`/profile/${user}`} className="user-name">
                  <h6>{name}</h6>
                </Link>
                <span className="text-muted time">
                  {' '}
                  <Moment calendar>{date}</Moment>
                </span>
              </div>
            </div>

            <p className="my-2 post-text">{text}</p>
            <div className="post-info mt-2">
              {likes.length > 0 && (
                <a href="#!" className="btn likes">
                  <i className="fas fa-thumbs-up"></i> {likes.length}
                </a>
              )}
              {comments.length > 0 && (
                <a
                  href="#!"
                  onClick={() => toggleCommentSection(!displayCommentSection)}
                  className="btn"
                >
                  {comments.length} <i className="fas fa-comment-alt"></i>
                </a>
              )}
            </div>
          </div>
          <hr className="my-0" />
          <div className="bg-light post-actions">
            {showActions && (
              <Fragment>
                {auth.user._id &&
                likes.filter((like) => like.user === auth.user._id).length >
                  0 ? (
                  <button
                    onClick={() => removeLike(_id)}
                    type="button"
                    className="btn btn-light likes active-likes py-1 px-3 rounded-0 mx-0"
                  >
                    <i className="fas fa-thumbs-up" /> Like
                  </button>
                ) : (
                  <button
                    onClick={() => addLike(_id)}
                    type="button"
                    className="btn btn-light py-1 px-3 rounded-0 mx-0"
                  >
                    <i className="far fa-thumbs-up" /> Like
                  </button>
                )}
              </Fragment>
            )}
            {displayCommentSection === true ? (
              <button
                onClick={() => toggleCommentSection(!displayCommentSection)}
                className="active-comment btn btn-light py-1 px-3 rounded-0 mx-0"
              >
                <i className="fas fa-comment-alt"></i> Comment
              </button>
            ) : (
              <button
                onClick={() => toggleCommentSection(!displayCommentSection)}
                className="btn btn-light py-1 px-3 rounded-0 mx-0"
              >
                <i className="far fa-comment-alt"></i> Comment
              </button>
            )}
          </div>
        </div>
        {displayCommentSection && (
          <div className="comment-section">
            {' '}
            <CommentForm postId={_id} />
            <div className="comments">
              {comments.map((comment) => (
                <CommentItem key={comment._id} comment={comment} postId={_id} />
              ))}
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

PostItem.defaultProps = {
  showActions: true
};

PostItem.propTypes = {
  post: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  addLike: PropTypes.func.isRequired,
  removeLike: PropTypes.func.isRequired,
  deletePost: PropTypes.func.isRequired,
  showActions: PropTypes.bool
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, { addLike, removeLike, deletePost })(
  PostItem
);
